import * as alertTypes from './actionTypes';

export const openAlert = (alertTitle, alertText) => (dispatch, getState) => {
  dispatch((() => ({ type: alertTypes.ALERT_OPEN, payload: { text: alertText, title: alertTitle } }))());
}

export const closeAlert = () => (dispatch, getState) => {
  dispatch((() => ({ type: alertTypes.ALERT_CLOSE }))());
};
